var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.43313 8C1.43313 7.72386 1.65699 7.5 1.93313 7.5H13.9331C14.2093 7.5 14.4331 7.72386 14.4331 8C14.4331 8.27614 14.2093 8.5 13.9331 8.5H1.93313C1.65699 8.5 1.43313 8.27614 1.43313 8Z",
    fill: "#8052D0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.28665 3.64645C6.48191 3.84171 6.48191 4.15829 6.28665 4.35355L2.64021 8L6.28665 11.6464C6.48191 11.8417 6.48191 12.1583 6.28665 12.3536C6.09139 12.5488 5.7748 12.5488 5.57954 12.3536L1.57955 8.35355C1.38429 8.15829 1.38429 7.84171 1.57955 7.64645L5.57954 3.64645C5.7748 3.45118 6.09139 3.45118 6.28665 3.64645Z",
    fill: "#8052D0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.d11c08b4.svg";
export { ForwardRef as ReactComponent };